export default __webpack_public_path__ + "static/media/star.a5be968f.png";